import { FormLayoutBuilder, getFormData } from '@pihealth/common-ui-library';
import Loader from 'src/components/common/Loader';
import { Box, Grid, Typography } from '@mui/material';
import AppModal from 'src/components/modal';
import staticData from '../../../resources/static.json';
import forms from '../../../resources/forms.json';
import { useRef } from 'react';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { ReactComponent as LongArrow } from './longArrow.svg';
const ShippedPopup: React.FunctionComponent<any> = props => {
  const { openShippedPopup, setOpenShippedPopup, statusData } = props;
  const shippedStatusData = staticData.Ship.shippedStatusData;
  const formGroup = forms.shippedActivity;
  const { formFields, rules } = getFormData(formGroup.groups);
  const formRef: any = useRef(null);
  const { groups } = formFields;
  const { preferedDateFormat } = usePreferedDateFormat();

  const handleCloseBtn = () => {
    setOpenShippedPopup(false);
  };

  return (
    <>
      <AppModal
        open={openShippedPopup}
        title={`${formGroup.header}- ${preferedDateFormat(statusData?.date_of_shipment)}`}
        closeButton={'Close'}
        handleClose={handleCloseBtn}
        maxWidth="600px"
        hideModalSaveButton
      >
        <Loader />
        <Grid container spacing={2} rowSpacing={1} mb="24px">
          {shippedStatusData.map((ele: any, index: number) => (
            <Grid item md={6} key={index}>
              <Typography variant="body1" sx={{ fontSize: 'clamp(14px, 15px, 16px)', wordBreak: "break-word" }}>
                <strong style={{ display: 'inline-block', minWidth: 'fit-content'}}>{ele.textValue}:&nbsp;</strong>
                <span className="results">{statusData?.[ele.apiKey]}</span>
              </Typography>
            </Grid>
          ))}
        </Grid>
        <FormLayoutBuilder initialValues={statusData} rules={rules} ref={formRef} groups={groups} columnSpacing={2} />
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', columnGap: 1, my: 4 }}>
          <Box sx={{ minWidth: '146px', textAlign: 'center' }}>
            <Typography variant="body1" gutterBottom>
              <strong>
                {statusData.depot_name} <br />[{statusData.depot_id}]
              </strong>
            </Typography>
            <Typography variant="body2" sx={{ fontSize: 'clamp(12px, 13px, 14px)' }}>
              <span className="results">
                Shipped on
                <br />
                {preferedDateFormat(statusData.date_of_shipment)}
              </span>
            </Typography>
          </Box>
          <Box
            sx={{
              minWidth: '216px',
              display: 'flex',
              alignItems: 'flex-end',
              overflow: 'hidden',
              '& svg path': { fill: 'black' }
            }}
          >
            <LongArrow />
          </Box>
          <Box sx={{ minWidth: '140px', textAlign: 'center' }}>
            <Typography variant="body1" gutterBottom>
              <strong>{statusData.site_id}</strong>
            </Typography>
            <Typography variant="body2" sx={{ fontSize: 'clamp(12px, 13px, 14px)' }}>
              <span className="results">
                Planned Delivery
                <br />
                {preferedDateFormat(statusData?.delivery_date)}
              </span>
            </Typography>
          </Box>
        </Box>
      </AppModal>
    </>
  );
};

export default ShippedPopup;
